export default "__VITE_ASSET__DgQnBHWS__"